import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';

import { SYNCBAK_DATA } from 'actions/playback';

const INITIAL_STATE = Immutable({
  loading: false,
  mvpdLogoUrl: null,
  error: null,
});

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case `${SYNCBAK_DATA}_LOADING`:
      return state.merge({ loading: true, error: null });
    case SYNCBAK_DATA:
      return state.merge({
        loading: false,
        mvpdLogoUrl: action.payload.mvpdLogoUrl,
        error: null,
      });
    case `${SYNCBAK_DATA}_ERROR`:
      return state.merge({ loading: false, error: action.payload });
    case 'CLEAR_SYNCBAK_DATA':
      return state.merge({ loading: false, mvpdLogoUrl: null, error: null });
    default:
      return state;
  }
};
